import { ToastContainerComponent } from "../src/components/ToastMessage/ToastMessage";
import Routing from "./routing/routing";
import './App.css';

function App() {
  return (
    <div className="pdfClass">
      <ToastContainerComponent />
      <Routing />
    </div>
  );
}
export default App;